import React, { useState, useEffect } from 'react';
import verseData from '../data/verses';
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDMO-NMJlMX-5M4px24r41ZstkhlBEtaeQ",
    authDomain: "good-news-from-josiah.firebaseapp.com",
    projectId: "good-news-from-josiah",
    storageBucket: "good-news-from-josiah.firebasestorage.app",
    messagingSenderId: "156596562213",
    appId: "1:156596562213:web:bf07b494a7d614025a12cc",
    measurementId: "G-5H5CL8C545"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

const VerseChoice = ({ translation, playerName, onGoBack }) => {
    const [verses, setVerses] = useState([]);
    const [correctIndex, setCorrectIndex] = useState(null);
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [totalAnswers, setTotalAnswers] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [feedbackClass, setFeedbackClass] = useState(null);
    const [book, setBook] = useState("");
    const [chapter, setChapter] = useState("");
    const [verse, setVerse] = useState("");
    const [timeLeft, setTimeLeft] = useState(60);
    const [gameOver, setGameOver] = useState(false);

    const loadNewVerse = () => {
        if (!translation || !verseData[translation]) return;

        const data = verseData[translation];
        const randomEntry = data[Math.floor(Math.random() * data.length)];
        const { book, chapter, verse, text, fake } = randomEntry;

        setBook(book);
        setChapter(chapter);
        setVerse(verse);

        const randomized = Math.random() > 0.5 ? [text, fake] : [fake, text];
        setVerses(randomized);
        setCorrectIndex(randomized.indexOf(text));
        setSelectedIndex(null);
        setFeedbackClass(null);
    };

    useEffect(() => {
        loadNewVerse();
        setTimeLeft(60);
        setGameOver(false);

        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    setGameOver(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [translation]);

    useEffect(() => {
        if (gameOver) {
            submitScore();
        }
    }, [gameOver]);

    const handleGuess = (index) => {
        if (gameOver) return;

        setSelectedIndex(index);
        setTotalAnswers((prev) => prev + 1);
        const isCorrect = index === correctIndex;

        if (isCorrect) {
            setCorrectAnswers((prev) => prev + 1);
            setFeedbackClass('correct');
        } else {
            setFeedbackClass('incorrect');
        }

        setTimeout(() => {
            loadNewVerse();
        }, 1000);
    };

    const handleReset = () => {
        setCorrectAnswers(0);
        setTotalAnswers(0);
        setSelectedIndex(null);
        setFeedbackClass(null);
        setTimeLeft(60);
        setGameOver(false);
        loadNewVerse();
    };

    const submitScore = async () => {
        try {
            await addDoc(collection(db, "bible-trivia"), {
                name: playerName,
                score: correctAnswers,
                total: totalAnswers,
                timestamp: serverTimestamp()
            });
        } catch (error) {
            console.error("Error submitting score:", error);
        }
    };

    return (
        <div>
            <h2>Which is Correct?</h2>

            <button className="back-button" onClick={onGoBack}>
                Start Over
            </button>

            <p><u>{`${book} ${chapter}:${verse}`}</u></p>

            <div className="verse-list">
                {verses.map((verse, i) => (
                    <div
                        key={i}
                        className={`verse-box ${selectedIndex === i ? feedbackClass : ''}`}
                        onClick={() => handleGuess(i)}
                    >
                        <p>{verse}</p>
                    </div>
                ))}
            </div>

            <div className="score-display">
                <p>Score: {correctAnswers} / {totalAnswers}<br></br>Time Left: {timeLeft}s</p>
            </div>

            {gameOver && (
                <div className="game-over-popup">
                    <div className="popup-content">
                        <h3>Time's Up!</h3>
                        <p>Your final score:</p>
                        <p>{correctAnswers} correct out of {totalAnswers} questions</p>
                        <button onClick={handleReset}>Play Again</button>
                        <button onClick={onGoBack}>Go Back</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VerseChoice;
